module.exports = __webpack_public_path__ + "static/img/03.fc574a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd108/03.png
// module id = GiE3
// module chunks = 1